
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M10.5 3.5c-6.5 0-8-.5-8 5s1.25 5 8 5zM10.5 5.5h3a1 1 0 1 1 0 2h-3zM10.5 9.5h3a1 1 0 1 1 0 2h-3z","stroke":"#798F8F"}})])
          )
        }
      }
    